/**********************************************************
Chemical Application Create
**********************************************************/
import ChemicalApplicationForm from './chem_app_form';
import CultivationModal from '../cult_modal';
import ChemicalAppList from './chem_app_list';
import ChemicalApplicationDisplay from './chem_app_display';
import { addSolution, selectSolutionToEdit, editSolution, deleteSolution,
  setTotalGallons, prepareData, createOrEditChemicalApplication, selectField,
  selectChemAppToEdit
  } from '../../actions/chem_app_actions';
import { fetchChemicals } from '../../actions/chem_actions';
import { fetchFields, fetchEmployees, fetchCertification, clearForm } from '../../actions/utils_actions';
import { packageForm, filterOldRecords } from '../../cult_utils';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class ChemicalApplicationCreate extends Component {
  componentDidMount() {
    if (this.props.chemicalList.length === 0) this.props.fetchChemicals();
    if (this.props.employees.length === 0) this.props.fetchEmployees();
    if (Object.keys(this.props.cert).length === 0) this.props.fetchCertification();
  }
  render() {
    return (
      <div>
        <div className="row">
        { Object.keys(this.props.user).length === 0 ? ''
          : this.props.user.level >= 3 || this.props.user.positionTitle.match(/Cultivation/) ?
          <div>
            <div className="col s12 m3 l3 xl3">
              <div className="chem-container">
                <ChemicalAppList chemAppList={this.props.chemicalApplications.filter(filterOldRecords)}
                  chemicals={this.props.chemicalList.filter((c) => c.type !== 'Fertilizer' && c.type !== 'Nutrient')}
                  onClick={(c) => this.props.selectChemAppToEdit({
                    formId: 'chemical-application-form',
                    chem: c,
                    chemicalList: this.props.chemicalList,
                    employees: this.props.employees
                  })} />
              </div>
            </div>
            <div className="col s12 m9 l9 xl9">
              <ChemicalApplicationForm formId={'chemical-application-form'} chemicalList={this.props.chemicalList.filter((c) => c.type !== 'Fertilizer' && c.type !== 'Nutrient')}
                fields={this.props.fields} employees={this.props.employees} solutions={this.props.solutions} isEditing={this.props.isEditing}
                totalGallons={this.props.totalGallons} eid={this.props.eid} cert={this.props.cert} editingApplication={this.props.editingApplication}
                setTotalGallons={this.props.setTotalGallons} fetchFields={this.props.fetchFields} addSolution={this.props.addSolution}
                selectField={this.props.selectField} editSolution={this.props.editSolution} deleteSolution={this.props.deleteSolution}
                selectSolutionToEdit={this.props.selectSolutionToEdit} _editSolution={this.props._editSolution}
              />
              <div className="row">
                <div className="col s12">
                  <div className="card-footer">
                    <a className="waves-effect waves-light btn modal-trigger" href={'#chem-app-prepare'}
                      onClick={() => this.props.prepareData({
                        user: this.props.user,
                        form: packageForm('chemical-application-form'),
                        selectedField: this.props.selectedField,
                        employees: this.props.employees,
                        solutions: this.props.solutions,
                        deletedSolutions: this.props.deletedSolutions,
                        submitter: this.props.eid,
                        certId: this.props.cert.certNo,
                        chemAppId: this.props.chemAppId,
                        editingApplication: this.props.editingApplication
                      })}>
                      Prepare
                    </a>
                    <button className="btn btn-flat" onClick={() => this.props.clearForm('chemical-application-form')}>Clear</button>
                  </div>
                  { this.props.editingApplication ?
                      CultivationModal(ChemicalApplicationDisplay)
                      // eslint-disable-next-line
                      ({ id: 'chem-app-prepare',
                         footer: true,
                         createOrEdit: true,
                         onClick: () => this.props.createOrEditChemicalApplication({
                           data: this.props.application,
                           type: 'EDIT_CHEMICAL_APPLICATION',
                           path: 'editChemicalApplication'
                         }),
                         application: this.props.application,
                         employees: this.props.employees,
                         solutions: this.props.solutions,
                         chemicalList: this.props.chemicalList,
                         previousApplications: this.props.previousApplications
                       })
                       :
                       CultivationModal(ChemicalApplicationDisplay)
                       // eslint-disable-next-line
                       ({ id: 'chem-app-prepare',
                          footer: true,
                          createOrEdit: true,
                          onClick: () => this.props.createOrEditChemicalApplication({
                            data: this.props.application,
                            type: 'CREATE_CHEMICAL_APPLICATION',
                            path: 'createChemicalApplication'
                          }),
                          application: this.props.application,
                          employees: this.props.employees,
                          solutions: this.props.solutions,
                          chemicalList: this.props.chemicalList,
                          previousApplications: this.props.previousApplications
                        })
                  }
                </div>
              </div>
            </div>
          </div>
          : <h5>Unauthorized</h5>
        }
        </div>
      </div>
    );
  }
}



function mapStateToProps(state) {
  return {
    application: state.cultivation.chemApp.app.application,
    cert: state.cultivation.utils.cert,
    chemicalApplications: state.cultivation.chemApp.chemicalApplications.displaying,
    chemAppId: state.cultivation.chemApp.app.chemAppId,
    chemicalList: state.cultivation.chemical.chemicalList,
    deletedSolutions: state.cultivation.chemApp.app.deletedSolutions,
    editingApplication: state.cultivation.chemApp.app.editingApplication,
    _editSolution: state.cultivation.chemApp.app.editSolution,
    eid: state.auth.user.guid,
    employees: state.cultivation.utils.employees,
    fields: state.cultivation.utils.fields,
    isEditing: state.cultivation.chemApp.app.isEditing,
    previousApplications: state.cultivation.chemApp.app.previousApplications,
    selectedField: state.cultivation.chemApp.app.selectedField,
    solutions: state.cultivation.chemApp.app.solutions,
    totalGallons: state.cultivation.chemApp.app.totalGallons,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addSolution,
    clearForm,
    createOrEditChemicalApplication,
    deleteSolution,
    editSolution,
    fetchCertification,
    fetchChemicals,
    fetchEmployees,
    fetchFields,
    prepareData,
    selectField,
    selectSolutionToEdit,
    selectChemAppToEdit,
    setTotalGallons
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ChemicalApplicationCreate);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_create.js